import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';
import React from 'react';
import { useTranslation } from 'react-i18next';

const RequestPasswordSuccess = ({ email }) => {
  const { t } = useTranslation();

  return (
    <div>
      <h1>{t('pages.forgot_password.success.title')}</h1>
      <WysiwygField
        property="schema:text"
        html={t('pages.forgot_password.success.body', { email })}
      />
    </div>
  );
};

export default RequestPasswordSuccess;
